import { Attempt } from '~/features/webhooks/types';
import { courier } from '~/services/serviceInstances';

interface Request {
  attempt: Attempt;
}

export const archiveAttempt = async ({
  attempt,
}: Request): Promise<boolean> => {
  //TODO: BE - Implement archive attempt API
  const response = await courier.post(`/delivery-attempts/${attempt.id}`);
  return Boolean(response);
};
